import { Link } from "react-router-dom";
import "./usecase.css";

export default function UseCase01() {
  return (
    <div className="uc-sheet" data-testid="usecase01-page">
      <main className="sheet">
        <header className="bar">
          <div className="brand"><span className="brand-mark">B</span>La Bascule</div>
          <span className="pill">Use case · 01 · Régie → Forfait</span>
        </header>

        <section className="hero">
          <aside className="id-card">
            <div className="photo">
              <span className="initials">MK</span>
              <span className="hint">Photo à insérer</span>
            </div>
            <div className="who">
              <h1>Mehdi</h1>
              <p>Data Engineer freelance</p>
            </div>
            <div className="facts">
              <div className="fact"><b>560 €</b><span>TJM en régie</span></div>
              <div className="fact"><b>+25 %</b><span>CA vs N-1</span></div>
            </div>
          </aside>

          <div className="headline">
            <span className="eyebrow">Résultat membre</span>
            <h2><em>22,5 K€</em> signés en 4 mois d'accompagnement.</h2>
            <p className="lede">Une coupure de mission, une expertise Data sous-valorisée. Mehdi a packagé ses pipelines de données en offre pour PME/ETI et a signé deux forfaits : un fabricant de cuisines, puis un e-commerçant. Son CA est à +25 % sur la même période N-1.</p>
            <div className="shift">
              <span className="from">560 €/j · régie</span>
              <span className="arrow">→</span>
              <span className="to">≈ 1 450 €/j · forfait</span>
            </div>
          </div>
        </section>

        <section className="grid">
          <article className="block parcours">
            <span className="eyebrow">Chapitre 01 — Le parcours</span>
            <h3>12 ans de Data chez les grands du retail, vendus au jour</h3>
            <p className="summary">Passé par Décathlon, GFI et Leroy Merlin, Mehdi a fait toute sa carrière entre BI, datawarehouse et DataOps. Une expertise rare sur la qualité et le traitement de la donnée, facturée comme un profil en régie.</p>
            <ul className="timeline">
              <li><div><b>Data Engineer freelance</b><span>Régie · 560 €/j</span></div></li>
              <li><div><b>BI Engineer puis DataOps</b><span>Décathlon · 8,3 ans</span></div></li>
              <li><div><b>RA Datawarehouse</b><span>GFI Informatique · 3 ans</span></div></li>
              <li><div><b>Ingénieur BI</b><span>Leroy Merlin · 6 mois</span></div></li>
            </ul>
            <div className="chips">
              <span className="chip">Pipelines de données</span>
              <span className="chip">Qualité de donnée</span>
              <span className="chip">ETL / ELT</span>
              <span className="chip">AWS</span>
            </div>
          </article>

          <article className="block motiv">
            <span className="eyebrow">Chapitre 02 — Le déclic</span>
            <h3>Pourquoi Mehdi a voulu basculer</h3>
            <div className="motiv-list">
              <div className="m">
                <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4 8.1 15.9"/><path d="M14.5 14.5 20 20"/><path d="M8.1 8.1 12 12"/></svg>
                <b>Coupure de projet client</b>
                <p>Une mission qui s'arrête, et le revenu avec. La dépendance à un seul client devient concrète.</p>
              </div>
              <div className="m">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 3 8l9 5 9-5-9-5Z"/><path d="m3 13 9 5 9-5"/></svg>
                <b>Valoriser ses expertises</b>
                <p>Être acheté pour une solution à un problème de données, plus pour un CV et un nombre de jours.</p>
              </div>
              <div className="m">
                <span className="big">120 K€+</span>
                <b>Objectif de revenu annuel</b>
                <p>Un cap difficile à franchir en régie sans vendre toujours plus de jours.</p>
              </div>
            </div>
          </article>

          <article className="block actions">
            <span className="eyebrow">Chapitre 03 — Ce qu'on a construit ensemble</span>
            <h3>Une offre, un pipeline, un process de vente</h3>
            <div className="steps">
              <div className="step">
                <span className="n">01 · OFFRE</span>
                <b>Offre Data Engineering packagée</b>
                <p>Mise en place de pipelines de données pour les PME/ETI qui ont des problèmes de qualité et de traitement de leur donnée.</p>
                <div className="tags"><span className="chip">PME / ETI</span><span class="chip">Qualité de donnée</span></div>
              </div>
              <div className="step">
                <span className="n">02 · ACQUISITION</span>
                <b>ICP et pipeline de prospection</b>
                <p>Définition du client idéal, puis un pipeline de prospection qui lui appartient, sans ESN ni plateforme.</p>
                <div className="tags"><span class="chip">ICP</span><span class="chip">Pipeline</span></div>
              </div>
              <div className="step">
                <span className="n">03 · CLOSING</span>
                <b>Process de vente en 4 étapes</b>
                <p>Un déroulé répétable, du premier call à la signature.</p>
                <div className="funnel"><span>R1</span><span>R2</span><span>Propal</span><span>Closing</span></div>
              </div>
            </div>
          </article>

          <article className="block result">
            <div className="res-copy">
              <span className="eyebrow">Chapitre 04 — Le résultat</span>
              <h3>Deux forfaits signés avant la fin des 4 mois.</h3>
              <ul className="deals">
                <li><span className="when">Sem. 10</span><div><b>Fabricant de cuisines</b><span>Pipeline de données · ±10 jours</span></div><strong>15 000 €</strong></li>
                <li><span className="when">Mois 4</span><div><b>E-commerçant</b><span>Traitement des données et outils de reporting · 5-6 jours</span></div><strong>7 500 €</strong></li>
              </ul>
              <p>À date, +25 % de CA sur la même période N-1, avec une rentabilité horaire qui a explosé.</p>
            </div>
            <div className="kpis">
              <div className="kpi hl"><b>22,5 K€</b><span>Signés en 4 mois</span></div>
              <div className="kpi"><b>+25 %</b><span>De CA vs N-1, même période</span></div>
              <div className="kpi"><b>≈16 <small>jours</small></b><span>De travail pour les 2 forfaits</span></div>
              <div className="kpi hl"><b>×2,6</b><span>≈ 1 450 €/j effectif vs 560 € TJM</span></div>
            </div>
          </article>

          <article className="compare" aria-label="Jours nécessaires pour atteindre 120 K€">
            <span className="eyebrow" style={{ gridColumn: "1 / -1" }}>Jours de travail pour atteindre 120 K€ / an</span>
            <span className="lab">Régie · 560 €/j</span>
            <div className="track"><div className="fill old">≈ 214 jours</div></div>
            <span className="lab">Forfait · ≈ 1 450 €/j</span>
            <div className="track"><div className="fill new">≈ 83 jours</div></div>
            <p className="cap">Projection au rythme des deux forfaits (22,5 K€ pour ≈ 15,5 jours). L'objectif de 120 K€ passe de 214 à environ 83 jours de production.</p>
          </article>
        </section>

        <footer className="foot">
          <span className="url">la-bascule.io</span>
          <Link className="cta" to="/offre" data-testid="usecase01-cta">Booker mon Check Up ↗</Link>
        </footer>
      </main>
    </div>
  );
}
